export const fileToDataUri = async (file: File): Promise<string> => {
  const fileReader = new FileReader();
  return new Promise(resolve => {
    fileReader.onload = () => {
      resolve(fileReader.result as string);
    };
    fileReader.readAsDataURL(file);
  });
};
